import React from 'react';

export function LoaderButtonLabel({ loading, children, loadingLabel = 'Searching...' }) {
  if (!loading) {
    return children;
  }

  return (
    <>
      <span className="epa-btn-spinner" aria-hidden="true" />
      {loadingLabel}
    </>
  );
}

export default function PageLoader({
  label = 'Loading...',
  compact = false,
  overlay = false,
}) {
  return (
    <div
      className={[
        'epa-page-loader',
        compact ? 'epa-page-loader-compact' : '',
        overlay ? 'epa-page-loader-overlay' : '',
      ].filter(Boolean).join(' ')}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="epa-page-loader-spinner">
        <span className="epa-page-loader-ring" />
      </div>
      {label ? <p className="epa-page-loader-label">{label}</p> : null}
    </div>
  );
}
